import { useRef } from 'react';

import debounce from 'lodash.debounce';

const useDebounce = (delay: number): ReturnType<typeof debounce> => {
  const ref = useRef(debounce(fn => fn(), delay));

  return ref.current;
};

export default useDebounce;
